import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";
import AB_2614 from "./AB_2614";
import Default from "./Default";

const abTests = {
    dev_2614__v2: loadUsualComponent(AB_2614),
};

const ListItemAccordion = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const isControlTheme = mainStore.getMainStore("theme") === "ab-control";
        const Specified = useAbTestComponent({ init, abTests: isControlTheme ? {} : abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default ListItemAccordion;
